import React from 'react';

const Header = ({ onOrderClick }) => {
  return (
    <header className="bg-white shadow-sm sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
        <div className="flex items-center">
          <h1 className="text-2xl font-bold text-gray-900">MPillar</h1>
          <span className="ml-2 text-sm bg-green-500 text-white px-2 py-1 rounded">AIQR Kit</span>
        </div>
        <button
          onClick={onOrderClick}
          className="bg-green-500 hover:bg-green-600 text-white px-6 py-2 rounded-lg font-semibold transition-colors"
          data-testid="header-order-button"
        >
          Order Now
        </button>
      </div>
    </header>
  );
};

export default Header;